import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type CollectionState = string[];

export const COLLECTION = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CollectionState>>,
): ConditionType<CollectionState, Condition.Collection> => ({
  name: "Collections",
  description(state) {
    return `Collections: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<CollectionState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.collections;
  },
  toModel(state) {
    return { type: Condition.COLLECTION, collections: state };
  },
  valid() {
    return true;
  },
});
